module.exports = "/_next/static/images/dgb-ffd41961217f1d96fa772e207f61fc12.svg";